import React from "react";
import TransactionCard from "./TransactionCard";
import '../Styles/TransactionCardList.scss';

const TransactionCardList = ({ transactions }) => {
   return (
      
         <div className="TransactionCardListContent">
            {transactions?.map((transaction) => <TransactionCard
               transaction={transaction} />)}
         </div>
   )
}

export default TransactionCardList;